import { BaseCFCStruct } from "../../../data/_config/shape"
import createCashFlowItem from "../../../state/CFC/createCashFlow"
import createCashFlowPlanItem from "./createCashFlow"

const initialValues: BaseCFCStruct = {
	canvasTitle: "",
	canvasType: "planirani",
	canvasTimeFrame: "mesečni",
	canvasStartDate: new Date(),
	canvasEndDate: new Date(),
	masterItems: [],
	step1Items: undefined,
	parentCanvasId: undefined,

	openingBalance: 0,
	paygWithholding: 0,
	superAmount: 0,
	incomeTax: 0,
	cashToOwner: 0,
	stock: 0,
	creditors: 0,
	debtors: 0,
	assets: 0,
	loans: 0,
	cashInItems: [createCashFlowItem()],
	cashOutItems: [createCashFlowItem()],
	cashItems: [],
	gstOnPurchases: undefined,
	gstOnSales: undefined,
	currentPlanMounth: undefined,
}

export default initialValues
